<script setup>
    import { routes } from '@/router'
    import router from '@/router'
    console.log('routes', routes)
    const links = routes.filter( (v, i) => {return !v.hidden})

    const checkCur = (item) => {
        const curPath = router.currentRoute._value.path
        console.log('this.$route', curPath)
        if(!routes.find((v, i)=>{return v.path == curPath}) && item.path =='/'){
            return true
        }
        return curPath == item.path
    }
</script>
<template>
    <div class="header">
        <router-link :key="item.path" :to="item.path" v-for="item in links"><span :class="{cur: checkCur(item)}" class="link">{{item.title}}</span></router-link>
    </div>
</template>
<style scoped>
.header{
    height: 64rem;
    display: flex;
    justify-content: center;
    border-bottom: solid 1px rgba(255, 255, 255, 0.2);
}
.link{
    padding: 0 55rem;
    line-height: 64rem;
    font-size: 18rem;
    color: #6A6C78;
}
.link.cur{
    font-weight: bold;
    color: #fff;
}
</style>